export default __webpack_public_path__ + "assets/53ee1583ca73f141154c90a50806bb74.png";